module.exports = require("@swa-ui/placements/src/BannerGrid/BannerGridLayout4.module.scss");